import { useState, useTransition } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { AFTER_GAME_CHANGE, createRound } from "@/api/mutations";
import { ApiError } from "@/api/client";

export function NovaRonda() {
  const queryClient = useQueryClient();
  const [erro, setErro] = useState<string | null>(null);
  const [aCriar, iniciar] = useTransition();

  function abrir() {
    setErro(null);
    iniciar(async () => {
      try {
        await createRound();
        for (const key of AFTER_GAME_CHANGE) {
          await queryClient.invalidateQueries({ queryKey: key });
        }
      } catch (error) {
        // The API says "Já há uma ronda a decorrer…" — its own wording.
        setErro(error instanceof ApiError ? error.message : "Não foi possível abrir a ronda.");
      }
    });
  }

  return (
    <div>
      <button
        type="button"
        onClick={abrir}
        disabled={aCriar}
        className="rounded-full bg-ouro px-5 py-2.5 font-semibold text-creme-50 transition-colors hover:bg-ouro-600 disabled:opacity-60"
      >
        {aCriar ? "A abrir…" : "Nova ronda"}
      </button>
      {erro && <p className="mt-2 text-sm text-rose-600">{erro}</p>}
    </div>
  );
}
